export const container = `max-w-full text-xs sm:text-base flex items-center gap-3 p-3 bg-base-white font-medium tracking-wider justify-end whitespace-nowrap data-[is-transparent=true]:bg-transparent h-10 sm:h-12`;
export const logoContainer = `w-28 sm:w-40`;
export const containerDeprecated = `flex items-center gap-3 p-3 bg-ll-background font-medium tracking-wider whitespace-nowrap max-w-full justify-end`;
// 152px is the width of the logo svg for optimal display
export const logoContainerDeprecated = `w-[152px]`;
